export default __webpack_public_path__ + "static/media/video-bg.74c5d299.webp";